import styles from './NoData.module.scss';
import images from 'assets/Images';

const NoData = props => {
	return (
		<>
			<div className={styles.container}>
				<div className={styles.container__content}>
					<img src={images.noDataImg} alt='no-data' />
					<h2>{props.title}</h2>
					<p>{props.description}</p>
				</div>
			</div>
		</>
	);
};

export default NoData;
